<app-system-maintenance
  *ngIf="showMessage"
  (closeModal)="closeModal()"
></app-system-maintenance>

<div
  class="row margin-bottom mb24 paperless agent row-section"
    [ngClass]="{'mb32':isAcmic}"
  *ngIf="
    (((policy?.policyFlags.isEftEligible === 'Y' &&
      policy?.isNewPolicy &&
      autoPay <= 0) ||
      (policy?.policyFlags.isEftEligible === 'Y' && !policy?.isNewPolicy)) &&
      policy?.policyStatus === 'ACTIVE' &&
      !(
        policy?.policyCancellationReason &&
        (policy?.policyCancellationReason.toLowerCase() ===
          'pay - non-payment of insurance premium' ||
          policy?.policyCancellationReason.toLowerCase() ===
            'fpd - failure to pay deposit') &&
        policy?.policyFlags.isEft === 'UNENROLLED'
      )) ||
    ((policy?.policyFlags.isEdfEligible === 'Y' ||
      policy?.policyFlags.isEbillEligible === 'Y') &&
      (policy?.policynumber?.policyNumber.length === 6 ||
        (policy?.policynumber?.policyNumber.length > 6 &&
          policy?.policyStatus === 'ACTIVE')))
  "
>
  <div class="col">
    <h2 class="title margin-bottom mb16 dm-sans-medium" [ngClass]="{'detail-sidebar-addrress':isAcmic, 'lh-24-imp': !isAcmic}"  *ngIf="policy?.company.companyName==='MA'">
      <ng-container *ngIf="!isAcmic; else acmicTitle">
        <ng-container
          *ngIf="(policy?.policyFlags?.isEft === 'ENROLLED' || policy?.policyFlags?.isEft === 'TRUE')
            && (policy?.policyFlags?.isEdf === 'ENROLLED' || policy?.policyFlags?.isEdf === 'TRUE'); else defaultNonAcmicTitle"
        >
          <span class="enrolled-in-text">You're enrolled in</span>
        </ng-container>
        <ng-template #defaultNonAcmicTitle>
          {{ "AUTOPAY_PAPERLESS" | translate }}
        </ng-template>
      </ng-container>
      <ng-template #acmicTitle>
        <ng-container
          *ngIf="(policy?.policyFlags?.isEft === 'ENROLLED' && policy?.policyFlags?.isEdf === 'ENROLLED'); else simplifyText">
          <div class="">You’re
            enrolled in</div>
        </ng-container>
        <ng-template #simplifyText>
          <div class="" [ngClass]="{'col-363636-imp': isAcmic}">
            Simplify your billing</div>
        </ng-template>
      </ng-template>
      
    </h2>
     <h2 class="title margin-bottom mb16 autohead dm-sans-medium" [ngClass]="{'detail-sidebar-addrress':isAcmic}" *ngIf="policy?.company.companyName !== 'MA'">
      {{ "autopay" }}
    </h2>
    <div class="row">
      <div class="col displayFlexRow" [ngClass]="{'enroll-text':!isAcmic}">
        <ng-container
          *ngIf="
            policy?.policyFlags.isEftEligible === 'Y' &&
            policy?.billingDetails?.[0]?.badCheckCount === 'N' &&
            policy?.billingDetails?.[0]?.mortageeFlag === 'N'
          "
        >          
          <ng-container *ngIf="isAutoPay">
            <ng-container [ngSwitch]="policy?.policyFlags.isEft">
              <ng-container *ngIf="isAcmic; else maAutopayMaintenence">
                <!-- <span *ngIf="policy?.policyFlags.isEft !== 'UPDATE-PENDING'" class="width75">
                  {{ "E-PAY" | translate }}
                </span> -->
                <a *ngSwitchCase="'ENROLLED'" [ngClass]="{'margin-bottom mb8': !isAcmic}">
                                    <img src="assets/img/images/Enrolled-state.svg" alt="payment convenience icon" />
                  <span [routerLink]="['/billing','autopay']" (click)="triggerDatalayer('Manage Autopay')" class="margin-left ml4 manage-autopay-paperless">{{ "MANAGE_AUTOPAY" | translate }}</span> 
                </a>
                <a
                  *ngSwitchCase="'UNENROLLED'"
                  [routerLink]
                  (click)="onShowMessage(); triggerDatalayer('Enroll in Autopay')" [ngClass]="{'margin-bottom mb8': !isAcmic}"
                >
                  <span class="btn-enroll" [ngClass]="{'fw-500': !isAcmic}"> {{ "ENROLL_IN_AUTOPAY" | translate }}</span>
                </a>
                <a
                  *ngSwitchCase="'ENROLLMENT-PENDING'"
                  [routerLink]
                  (click)="onShowMessage()" [ngClass]="{'margin-bottom mb8': !isAcmic}"
                >
                  {{ "PENDING_ENROLLMENT" | translate }}
                  <img src="assets/img/images/icon-edit-acmic-24.svg" class="ml8 edit-icon-mt-5" alt="edit icon" />
                </a>
              </ng-container>
              <ng-template #maAutopayMaintenence>
                <a *ngSwitchCase="'ENROLLED'" [ngClass]="{'margin-bottom mb8': !isAcmic}">
                  <img class="enrolled-icon" src="assets/img/images/Enrolled-state.svg" alt="payment convenience icon" />
                  {{ "ENROLLED_TEXT" | translate }}
                  <span class="width75"> {{ "E-PAY" | translate }} </span>
                </a>
                <a
                  *ngSwitchCase="'UNENROLLED'"
                  [routerLink]
                  (click)="onShowMessage()"
                  class="enroll-status-button" [ngClass]="{'margin-bottom mb8 fw-500': !isAcmic}"
                >
                  <!-- <img src="assets/img/images/icon-payment-convenience-red.svg" alt="payment convenience icon" /> -->
                  {{ "NOT_ENROLLED_TEXT" | translate }}
                  <span class="width75" [ngClass]="{'fw-500': !isAcmic}"> {{ "AUTOPAY_MA" | translate }} </span>                  
                </a>
                <a
                  *ngSwitchCase="'ENROLLMENT-PENDING'"
                  [routerLink]
                  (click)="onShowMessage()"
                  class="enroll-status-button show-more-button stuffer-underline" [ngClass]="{'enroll-pending-button margin-bottom mb8 fw-500':!isAcmic}"
                >
                  <!-- <img src="assets/img/images/icon-payment-convenience-red.svg" alt="payment convenience icon" /> -->
                  {{ "PENDING_ENROLLMENT" | translate }}
                  <span class="margin-left ml-0"> {{ "AUTOPAY_MA" | translate }} </span>
                </a>
              </ng-template>              
            </ng-container>
          </ng-container>
          <ng-container *ngIf="!isAutoPay">
            <ng-container [ngSwitch]="policy?.policyFlags.isEft">
              <ng-container *ngIf="isAcmic; else maAutopay">
                <!-- <span *ngIf="policy?.policyFlags.isEft !== 'UPDATE-PENDING'" class="width75">
                  {{ "E-PAY" | translate }}
                </span> -->
                 <a *ngSwitchCase="'ENROLLED'" [ngClass]="{'margin-bottom mb8': !isAcmic}">
                  <img class="enrolled-icon-acmic" src="assets/img/images/Enrolled-state.svg" alt="payment convenience icon" />
                  <span [routerLink]="['/billing','autopay']" (click)="triggerDatalayer('Manage Autopay')" class="margin-left ml4 manage-autopay-paperless">{{ "MANAGE_AUTOPAY" | translate }}</span> 
                </a>           
                <a
                  *ngSwitchCase="'UNENROLLED'"
                  [routerLink]="['/billing', 'autopay']"
                  (click)="triggerDatalayer('Enroll in Autopay')" [ngClass]="{'margin-bottom mb8 ': !isAcmic}"
                >
                    <span class="btn-enroll" [ngClass]="{'fw-500': !isAcmic}"> {{ "ENROLL_IN_AUTOPAY" | translate }}</span>
                </a>
                <a
                  *ngSwitchCase="'ENROLLMENT-PENDING'"
                  [routerLink]="['/billing', 'autopay']" [ngClass]="{'margin-bottom mb8': !isAcmic}"
                >
                  {{ "PENDING_ENROLLMENT" | translate }}
                  <img src="assets/img/images/icon-edit-acmic-24.svg" class="ml8 edit-icon-mt-5" alt="edit icon" />
                </a>   
              </ng-container>
              <ng-template #maAutopay>
                <a  class="enrolled-gap" *ngSwitchCase="'ENROLLED'" [ngClass]="{'margin-bottom mb8': !isAcmic}">
                  <img class="enrolled-icon" src="assets/img/images/Enrolled-state.svg" alt="payment convenience icon" />
                  <!-- {{ "ENROLLED_TEXT" | translate }} -->
                  <span class="width75 autopay-text"> {{ "E-PAY" | translate }} </span>
                </a>
                <a
                  *ngSwitchCase="'UNENROLLED'" 
                  [routerLink]="['/billing', 'autopay']"
                  class="enroll-status-button btn-enroll enroll-status-link" [ngClass]="{'autopayBtn margin-bottom mb8 fw-500':!isAcmic}"
                >
                <!-- <img src="assets/img/images/icon-payment-convenience-red.svg" alt="payment convenience icon" [ngClass]="{'margin-right mr4':!isAcmic}"/> -->
                {{ "NOT_ENROLLED_TEXT" | translate }}
                 {{ "AUTOPAY_MA" | translate }} 
                </a>
                <a
                  *ngSwitchCase="'ENROLLMENT-PENDING'"
                  [routerLink]="['/billing', 'autopay']"
                  class="enroll-status-button show-more-button stuffer-underline" [ngClass]="{'enroll-pending-button margin-bottom mb8 fw-500':!isAcmic}"
                >
                <!-- <img src="assets/img/images/icon-payment-convenience-red.svg" alt="payment convenience icon" /> -->
                {{ "PENDING_ENROLLMENT" | translate }}
                <span class="margin-left ml-0"> {{ "AUTOPAY_MA" | translate }} </span> 
                </a>   
              </ng-template>                       
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div class="row">
      <div class="col displayFlexRow" [ngClass]="{'enroll-text':!isAcmic,'displayflexrow-acmic':isAcmic}">
        <ng-container
          *ngIf="
            policy?.policyType !== 'COMMERCIAL_AUTO' &&
              policy?.policyType !== 'GARAGE_KEEPER';
            else commercialTemp
          "
        >
          <ng-container *ngIf="policy?.policyFlags.isEdfEligible === 'Y'">
            <ng-container *ngIf="isPaperless">
              <ng-container [ngSwitch]="true">                
                <ng-container *ngIf="isAcmic; else maPaperlessMaintenence"> 
                  <!-- <span class="width75"> {{ "PAPERLESS" | translate }}: </span>   -->
                  <a
                  *ngSwitchCase="
                    policy?.policyFlags.isEdf === 'ENROLLED' ||
                    policy?.policyFlags.isEdf === 'TRUE'
                  "
                >
                  <img class="enrolled-icon-acmic" src="assets/img/images/Enrolled-state.svg" alt="payment convenience icon" />
                    <span [routerLink]="['/billing','paperless']" (click)="triggerDatalayer('Manage Paperless')" class="margin-left ml4 manage-autopay-paperless">{{ "MANAGE_PAPERLESS" |
                      translate }}</span>
                </a>                
                <a
                  *ngSwitchCase="
                    policy?.policyFlags.isEdf === 'UNENROLLED' ||
                    policy?.policyFlags.isEdf === 'FALSE'
                  "
                  [routerLink]
                  (click)="onShowMessage(); triggerDatalayer('Enroll in Paperless')"
                >
                  <span class="btn-enroll" [ngClass]="{'fw-500': !isAcmic}"> {{ "ENROLL_IN_PAPERLESS" | translate }}</span>
                </a>
                <a
                  *ngSwitchCase="
                    policy?.policyFlags.isEdf === 'ENROLLMENT-PENDING'
                  "
                  [routerLink]
                  (click)="onShowMessage();"
                >
                  {{ "PENDING_ENROLLMENT" | translate }}
                  <img src="assets/img/images/icon-edit-acmic-24.svg" class="ml8 edit-icon-mt" alt="edit icon" />
                </a>
                </ng-container>
                <ng-template #maPaperlessMaintenence>
                  <a *ngSwitchCase="
                                    policy?.policyFlags.isEdf === 'ENROLLED' ||
                                    policy?.policyFlags.isEdf === 'TRUE'
                                  " [ngClass]="{'fw-500': !isAcmic}">
                    <img src="assets/img/images/Enrolled-state.svg" alt="write icon" />
                    {{ "ENROLLED_TEXT" | translate }}
                    <span class="width75 paperless-text" [ngClass]="{'fw-500': !isAcmic}"> {{ "PAPERLESS" | translate | lowercase }}</span>
                  </a>
                  <a *ngSwitchCase="
                                    policy?.policyFlags.isEdf === 'UNENROLLED' ||
                                    policy?.policyFlags.isEdf === 'FALSE'
                                  " [routerLink] (click)="onShowMessage()" class="enroll-status-button" [ngClass]="{'fw-500': !isAcmic}">
                    <!-- <img src="assets/img/images/icon-write-red.svg" alt="write icon" /> -->
                    {{ "NOT_ENROLLED_TEXT" | translate }}
                    <span class="width75 paperless-text" [ngClass]="{'fw-500': !isAcmic}"> {{ "E-POLICY" | translate | lowercase}}</span>                    
                  </a>
                  <a *ngSwitchCase="
                                    policy?.policyFlags.isEdf === 'ENROLLMENT-PENDING'
                                  " [routerLink] (click)="onShowMessage()" class="enroll-status-button" [ngClass]="{'enroll-pending-button':!isAcmic}" >
                    <!-- <img src="assets/img/images/icon-write-red.svg" alt="write icon" /> -->
                    {{ "PENDING_ENROLLMENT" | translate }}
                    <span class="paperless-text"> {{ "PAPERLESS" | translate | lowercase}}</span>
                  </a>
                </ng-template>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!isPaperless">
              <ng-container *ngIf="isAcmic; else maPaperless">
                <!-- <span class="width75"> {{ "PAPERLESS" | translate }}: </span> -->
                <ng-container [ngSwitch]="true">
                  <a
                    *ngSwitchCase="
                      policy?.policyFlags.isEdf === 'ENROLLED' ||
                      policy?.policyFlags.isEdf === 'TRUE'
                    "
                  >
                    <img class="enrolled-icon-acmic" src="assets/img/images/Enrolled-state.svg" alt="payment convenience icon" />
                    <span [routerLink]="['/billing','paperless']" (click)="triggerDatalayer('Manage Paperless')" class="margin-left ml4 manage-autopay-paperless">{{ "MANAGE_PAPERLESS" |
                      translate }}</span>                 
                  </a>                
                  <a
                    *ngSwitchCase="
                      policy?.policyFlags.isEdf === 'UNENROLLED' ||
                      policy?.policyFlags.isEdf === 'FALSE'
                    "
                    [routerLink]="['/billing', 'paperless']" (click)="triggerDatalayer('Enroll in Paperless')"
                  >
                    <span class="btn-enroll" [ngClass]="{'fw-500': !isAcmic}"> {{ "ENROLL_IN_PAPERLESS" | translate }}</span>

                  </a>
                  <a
                    *ngSwitchCase="
                      policy?.policyFlags.isEdf === 'ENROLLMENT-PENDING'
                    "
                    [routerLink]="['/billing', 'paperless']"
                  >
                    {{ "PENDING_ENROLLMENT" | translate }}
                    <img src="assets/img/images/icon-edit-acmic-24.svg" class="ml8 edit-icon-mt" alt="edit icon" />
                  </a>
                </ng-container>
              </ng-container>
              <ng-template #maPaperless>
                <ng-container [ngSwitch]="true">
                  <a class="paperless-enrolled-gap"
                    *ngSwitchCase="
                      policy?.policyFlags.isEdf === 'ENROLLED' ||
                      policy?.policyFlags.isEdf === 'TRUE'
                    "
                  >
                    <!-- {{ "ENROLLED_TEXT" | translate }}                   -->
                   <img class="enrolled-icon" src="assets/img/images/Enrolled-state.svg" alt="write icon" />
                    <span class="width75 paperless-text"> {{ "PAPERLESS" | translate  }}</span>
                  </a>                
                  <a
                    *ngSwitchCase="
                      policy?.policyFlags.isEdf === 'UNENROLLED' ||
                      policy?.policyFlags.isEdf === 'FALSE'
                    "
                    [routerLink]="['/billing', 'paperless']" class="enroll-status-button btn-enroll" [ngClass]="{'paperlessBtn fw-500':!isAcmic}"
                  >
                    {{ "NOT_ENROLLED_TEXT" | translate }} {{ "E-POLICY" | translate | lowercase}}
                  </a>
                  <a 
                    *ngSwitchCase="
                      policy?.policyFlags.isEdf === 'ENROLLMENT-PENDING'
                    "
                    [routerLink]="['/billing', 'paperless']" class="enroll-status-button" [ngClass]="{'enroll-pending-button':!isAcmic}"
                  >
                  <!-- <img src="assets/img/images/icon-write-red.svg" alt="write icon" /> -->
                    {{ "PENDING_ENROLLMENT" | translate }}
                    <span class="paperless-text"> {{ "PAPERLESS" | translate | lowercase}}</span>
                  </a>                  
                </ng-container>
              </ng-template>              
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-template #commercialTemp>
          <ng-container *ngIf="policy?.policyFlags.isEbillEligible === 'Y'">
            <ng-container [ngSwitch]="true">
              <ng-container *ngIf="isAcmic; else commercialMaintenence">
                <span class="width75"> {{ "E-BILL_TEXT" | translate }}: </span>
                <a
                *ngSwitchCase="
                  policy?.policyFlags.isEbill === 'ENROLLED' ||
                  policy?.policyFlags.isEbill === 'TRUE'
                "
              >
                {{ "ENROLLED_TEXT" | translate }}                
              </a>              
              <a
                *ngSwitchCase="
                  policy?.policyFlags.isEbill === 'UNENROLLED' ||
                  policy?.policyFlags.isEbill === 'FALSE'
                "
                [routerLink]="['/billing', 'paperless']" [ngClass]="{'fw-500': !isAcmic}"
              >
                {{ "NOT_ENROLLED_TEXT" | translate }}
                <img src="assets/img/images/icon-edit-acmic-24.svg" class="ml8 edit-icon-mt-5" alt="edit icon" />
              </a>
              <a
                *ngSwitchCase="
                  policy?.policyFlags.isEbill === 'ENROLLMENT-PENDING'
                "
                [routerLink]="['/billing', 'paperless']"
              >
                {{ "PENDING_ENROLLMENT" | translate }}
                <img src="assets/img/images/icon-edit-acmic-24.svg" class="ml8 edit-icon-mt-5" alt="edit icon" />
              </a>
              </ng-container>
              <ng-template #commercialMaintenence>
                <a
                *ngSwitchCase="
                  policy?.policyFlags.isEbill === 'ENROLLED' ||
                  policy?.policyFlags.isEbill === 'TRUE'
                " [ngClass]="{'fw-500': !isAcmic}"
              ><img class="enrolled-icon enrolled-icon-ebill" src="assets/img/images/Enrolled-state.svg" alt="write icon" />
                <!-- {{ "ENROLLED_TEXT" | translate }}   -->
                <span class="width75" [ngClass]="{'fw-500': !isAcmic}"> {{ "E-BILL_TEXT" | translate }}</span>              
              </a>              
              <a
                *ngSwitchCase="
                  policy?.policyFlags.isEbill === 'UNENROLLED' ||
                  policy?.policyFlags.isEbill === 'FALSE'
                "
                [routerLink]="['/billing', 'paperless']" class="enroll-status-button  btn-enroll " [ngClass]="{'enrl-ebill-button fw-500': !isAcmic}" 
              >
              <!-- <img src="assets/img/images/icon-write-red.svg" alt="write icon"/> -->
                {{ "NOT_ENROLLED_TEXT" | translate }}
                <span class="width75 btn-enroll" [ngClass]="{'fw-500': !isAcmic}"> {{ "E-BILL_TEXT" | translate }}</span>
              </a>
              <a
                *ngSwitchCase="
                  policy?.policyFlags.isEbill === 'ENROLLMENT-PENDING'
                "
                [routerLink]="['/billing', 'paperless']" class="enroll-status-button" [ngClass]="{'enroll-pending-button':!isAcmic}"
              ><img src="assets/img/images/icon-write-red.svg" alt="write icon" />
                {{ "PENDING_ENROLLMENT" | translate }}
                <span> {{ "E-BILL_TEXT" | translate }}</span>
              </a>
              </ng-template>
                            
            </ng-container>
          </ng-container>
        </ng-template>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!isAcmic" class="row margin-bottom mb24 agent row-section">
  <div class="col">
    <h2 class="title margin-bottom mb16 dm-sans-medium">
      <div class="svg-container">
       
      </div>
      {{ "YOUR_AGENT" | translate }}
    </h2>
    <strong>
      <span class="fs-16">{{
        policy?.agent.agentName
      }}</span>
    </strong>
    <p
      class="title-case no-margin-bottom" [ngClass]="{'grey-color':!isAcmic}"
      *ngIf="policy?.agent?.address !== undefined"
    >
      {{ policy.agent.address.streetName | titlecase }}
      {{ policy.agent.address.city | titlecase }},
      {{ policy.agent.address.stateCode }},
      {{ policy.agent.address.zipCode.code }}
    </p>
    <div class="row agent-phone-tab" *ngIf="policy?.agent?.agentISCPhone?.number">
      <div class="col col-tab-desc" [ngClass]="{'grey-color':!isAcmic}">{{ "PHONE" | translate }}:</div>
      <div class="col col-tab-info">
        <a href="tel:{{ policy.agent.agentISCPhone?.number }}" class="mapfre link red-link underline">
          {{ policy.agent.agentISCPhone?.number | formatPhone }}</a>
      </div>
    </div>
    <div class="row agent-phone-tab"
      *ngIf="
        policy?.agent?.agentPhone?.number &&
        !policy?.agent?.agentISCPhone?.number
      "
    >
      <div class="col col-tab-desc" [ngClass]="{'grey-color':!isAcmic}">
        {{ "PHONE" | translate }}:
      </div>
      <div class="col col-tab-info">
        <a href="tel:{{ policy.agent.agentPhone?.number }}" class="mapfre link red-link underline">
          {{ policy.agent.agentPhone?.number | formatPhone }}</a
        >
      </div>
    </div>
    <div class="row agent-email-tab" *ngIf="policy?.agent?.agentEmail && policy?.agent?.agentEmail.trim().length > 0">
      <div class="col col-tab-desc" [ngClass]="{'grey-color':!isAcmic}">
        {{ "EMAIL" | translate }}: 
      </div>
      <div class="col col-tab-info">
        <a href="mailto:{{ policy?.agent?.agentEmail }}" class="mapfre link red-link underline">
          {{ policy?.agent?.agentEmail }}</a>
      </div>
    </div>
  </div>
</div>

<div
  class="row margin-bottom margin-bottom mb32 row-section"
  *ngIf="
    policy?.policyStatus === 'ACTIVE' &&
    (policy?.policyType === 'AUTO' || policy?.policyType === 'HOME')
  "
>
  <div class="col" >
    <h2 class="title margin-bottom mb16 dm-sans-medium" [ngClass]="{ 'detail-sidebar-addrress': isAcmic, 'col-363636-imp': isAcmic}" >
      {{ "ADDRESS" | translate }}
    </h2>
    <ng-container *ngIf="isAcmic; else maAddress">
      <div class="residential-add margin-bottom mb32 address">
        <div class="row">
          <div class="col">
            <strong class="fs-16"> {{ "RESIDENTIAL" | translate }}</strong>
          </div>
        </div>
        <div class="row ">
          <div class="col address-copy text-capitalize mb-8 w-270">
            <ng-container *ngIf="aptResidentialNumber; else withoutApt">
              <div>{{ residentialStreetName | titlecase }}</div>
              <div>Apt {{aptResidentialNumber}}</div>
            </ng-container>
            <ng-template #withoutApt>
              <div>{{ policy.residentialAddress.streetName | titlecase }}</div>
            </ng-template>
            <div> {{ policy.residentialAddress.city | titlecase }}, {{ policy.residentialAddress.state | fullstateToAbv }} {{ policy.residentialAddress.zipCode.code }}</div>
          </div>
        </div>
        <div class="edit-address ">
          <mapfre-button
          (click)="
          getMailingOrResidentialAddress(
            policy.residentialAddress,
            'residential',
            policyId
          )" *ngIf="policy.policyType === 'AUTO'"
              additionalClasses="ghost secondary letter-space-17 no-padding detail-sidebar-btn"                    
            >{{ "EDIT" | translate }}
          </mapfre-button>
        </div>
      </div>
      <div class="mailing-add margin-top mt24 margin-bottom mb8 address" *ngIf="policy?.mailingAddress">
        <div class="row">
          <div class="col" [ngClass]="{'col-363636-imp': isAcmic}">
            <strong class="fs-16"> {{ "MAILING" | translate }}</strong>
          </div>
        </div>
        <div class="row">
          <ng-container *ngIf="!isItTheSameAddress; else sameAsMailing">
            <div class="col address-copy  mb-8 w-270">
              <ng-container *ngIf="isAcmic; else maAddress">
                <ng-container *ngIf="aptMailingNumber; else withoutApt">
                  <div>{{ mailingStreetName | titlecase }}</div>
                  <div>Apt {{aptMailingNumber}}</div>
                </ng-container>
                <ng-template #withoutApt>
                  <div>{{ policy.mailingAddress.streetName | titlecase }}</div>
                </ng-template>
                <div> {{ policy.mailingAddress.city | titlecase }}, {{ policy.mailingAddress.state | fullstateToAbv }} {{
                  policy.mailingAddress.zipCode.code }}</div>
              </ng-container>
              <ng-template #maAddress>
                <div>{{ policy?.mailingAddress?.streetName | titlecase }}</div>
                <div>
                  {{ policy?.mailingAddress?.city | titlecase }}
                  {{ policy?.mailingAddress?.state | fullstateToAbv }}
                  {{ policy?.mailingAddress?.zipCode.code }}
                </div>
              </ng-template>
            </div>
          </ng-container>
          <ng-template #sameAsMailing>
            <div class="col address-copy mb-8 w-270">
              {{ "SAME_AS_MAILING" | translate }}
            </div>
          </ng-template>
        </div>
        <div class=" edit-address " >
          <mapfre-button
          (click)="
          getMailingOrResidentialAddress(
            policy.mailingAddress,
            'mailing',
            policyId
          )" 
          additionalClasses="ghost secondary letter-space-17 no-padding detail-sidebar-btn"                    
          >{{ "EDIT" | translate }}
        </mapfre-button>
         
        </div>
      </div>
    </ng-container>
    <ng-template #maAddress>
      <div class="residential-add margin-bottom mb16 address">
        <div class="row">
          <div class="col">
            <img class="margin-right mr4" src="assets/img/images/icon-location-map.svg" alt="location map icon" />          
            <strong class="fs-16"> {{ "RESIDENTIAL" | translate }}</strong>
          </div>
        </div>
        <div class="row margin-left ml16">
          <div class="col address-copy text-capitalize">
            {{ policy.residentialAddress.streetName | titlecase }},
            {{ policy.residentialAddress.city | titlecase }},
            {{ policy.residentialAddress.state | fullstateToAbv }},
            {{ policy.residentialAddress.zipCode.code }}
          </div>         
        </div>
        <div class="row margin-left ml16" *ngIf="policy.policyType === 'AUTO' && 
        company!== 'ACIC'">
          <div class="col edit-button margin-top mt8">
            <mapfre-button
              (click)="getMailingOrResidentialAddress(
                policy.residentialAddress,
                'residential',
                policyId
              )"
              additionalClasses="x-small-btn"                    
            >
              {{ "EDIT" | translate }}
            </mapfre-button>
          </div>
        </div>
      </div>
      <div class="mailing-add margin-top mt16 margin-bottom mb8 address" *ngIf="policy?.mailingAddress">
        <div class="row">
          <div class="col">
            <img class="margin-right mr4" src="assets/img/images/icon-email.svg" alt="email icon" />
            <strong class="fs-16"> {{ "MAILING" | translate }}</strong>
          </div>
        </div>
        <div class="row margin-left ml16">
          <ng-container *ngIf="!isItTheSameAddress; else sameAsMailing">
            <div class="col address-copy">
              {{ policy?.mailingAddress?.streetName | titlecase }},
              {{ policy?.mailingAddress?.city | titlecase }},
              {{ policy?.mailingAddress?.state | fullstateToAbv }},
              {{ policy?.mailingAddress?.zipCode.code }}
            </div>
          </ng-container>
          <ng-template #sameAsMailing>
            <div class="col address-copy">
              {{ "SAME_AS_MAILING" | translate }}
            </div>
          </ng-template>          
        </div>
        <div class="row margin-left ml16" *ngIf="company!== 'ACIC'">
          <div class="col edit-button margin-top mt8">
            <mapfre-button
              (click)="getMailingOrResidentialAddress(
                policy.mailingAddress,
                'mailing',
                policyId
              )"
              additionalClasses="x-small-btn w64"                    
            >
              {{ "EDIT" | translate }}
            </mapfre-button>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
<ng-container *ngIf="isEligibleForUpload || isAcmic">
  <div class="row addresses row-section">
    <div class="col">
      <h2 class="title margin-bottom mb16 dm-sans padding-top pt16 lh-24-imp" [ngClass]="{'link-policy-h2 fw-400':isAcmic, 'col-363636-imp': isAcmic}">
        {{ "Need to send us a document?" | translate }}
      </h2>
      <section class="billing-request-help mt-3">
        <app-upload-type-modal [policy]="policy"></app-upload-type-modal>
      </section>
    </div>
  </div>
</ng-container>